export default __webpack_public_path__ + "static/jetson_background_land_desktop_home-d9db230f863361d0c9193e82e07ae4b1.jpg";